import { useKnownAvailableParams } from '@change-corgi/core-react/router';

import type { PrefetchContext, PrefetchedDataProps } from '#src/shared/prefetch';

import { prefetchSocialStarterPageDataFromApi, useSocialStarterPageDataFromApi } from './pageData';

export type SocialStarterPrefetchedContext = Readonly<{
	pageData: Parameters<typeof useSocialStarterPageDataFromApi>[0];
}>;

export type SocialStarterCombinedState = ReturnType<typeof useSocialStarterPageDataFromApi>;

export function usePageContext(prefetchedData?: SocialStarterPrefetchedContext): SocialStarterCombinedState {
	const { token } = useKnownAvailableParams<{ token: string }>();
	return useSocialStarterPageDataFromApi(prefetchedData?.pageData, token);
}

export async function prefetchPageContext(context: PrefetchContext): Promise<SocialStarterPrefetchedContext> {
	const token = context.params.token ?? '';
	const pageData = await prefetchSocialStarterPageDataFromApi(context, token);
	return { pageData };
}

export type SocialStarterPrefetchedDataProps = PrefetchedDataProps<SocialStarterPrefetchedContext>;
